import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";

export function useSpotlightVideos(advertisementId: number, asin: string) {
  return useQuery({
    queryKey: [{ endpoint: "getSpVideo", advertisementId, asin }],
    queryFn: async () => await apiClient.getSpVideo({ params: { id: advertisementId }, queries: { asin } }),
    enabled: !!advertisementId && !!asin,
  });
}
